export const STYLE = {
  SOLID: 'solid',
  DASHED: 'dashed',
} as const;
